var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#00EC97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6759 17.6359L34.9902 27.5577C34.5279 28.2334 35.4169 29.0513 36.057 28.4823L42.636 22.7568C42.8138 22.6146 43.0628 22.7212 43.0628 22.9702V40.8579C43.0628 41.1069 42.7427 41.2136 42.6005 41.0357L22.6857 17.2091C22.0456 16.4267 21.1209 16 20.0896 16H19.3784C17.5292 16 16 17.5292 16 19.414V44.592C16 46.4767 17.5292 48.0059 19.414 48.0059C20.5875 48.0059 21.6899 47.4014 22.3301 46.3701L29.0157 36.4482C29.478 35.7725 28.589 34.9546 27.9489 35.5236L21.3699 41.2136C21.1921 41.3558 20.9431 41.2491 20.9431 41.0002V23.148C20.9431 22.8991 21.2632 22.7924 21.4054 22.9702L41.3202 46.7968C41.9604 47.5792 42.9205 48.0059 43.9163 48.0059H44.6275C46.5123 48.0059 48.0415 46.4767 48.0415 44.592V19.414C48.0415 17.5292 46.5123 16 44.6275 16C43.4184 16 42.316 16.6046 41.6759 17.6359Z",
    fill: "#020001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/NEAR.5017d2c98dff81f68c85b98f528eef33.svg";
export { ForwardRef as ReactComponent };